module.exports = __webpack_public_path__ + "assets/icon-warning.062fbcbf.svg";